import React, { useState, useEffect, useCallback } from 'react';

import { CompanySelectModel } from 'api/adminApiClient';
import { ContractorCompanyFilterTypes } from '../../enums';
import CompanyFilter from 'components/filters/CompanyFilter';
import { getContractorCompanyCompanies } from 'redux/reducers/contractorCompanySlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

export interface ContractorCompanyFilters {
  [ContractorCompanyFilterTypes.Company]?: string[];
}

type Props = {
  filters: ContractorCompanyFilters;
  onChange: (data: ContractorCompanyFilters) => void;
  value?: string[];
};

export default function ContractorCompanyFilter(props: Props) {
  const { filters, onChange, value } = props;
  const [companies, setCompanies] = useState<CompanySelectModel[]>([]);
  const [isCompaniesLoaded, setIsCompaniesLoaded] = useState(false);

  const dispatch = useAppDispatch();

  const loadCompanies = useCallback(async () => {
    const result = await dispatch(getContractorCompanyCompanies());

    if (getContractorCompanyCompanies.fulfilled.match(result)) {
      setCompanies(result.payload);
    }
    setIsCompaniesLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadCompanies();
  }, [loadCompanies]);

  return (
    <CompanyFilter<ContractorCompanyFilters>
      filters={filters}
      onChange={onChange}
      companies={companies}
      isCompaniesLoaded={isCompaniesLoaded}
      value={value}
    />
  );
}
